import cx from 'classnames'
import React, { FC, Fragment } from 'react'

import useMediaQuery from '../../hooks/useMediaQuery'
import { ActionButtonProps } from '../ActionButton'

import * as SC from './styled'

type Column = {
  label?: string
  value: React.ReactNode
  onClick?: () => void
  shrink?: boolean
}

export type AdsTableItemProps = {
  className?: string
  columns: Array<Column>
  actions: Array<ActionButtonProps>
  outsideSlot?: React.ReactNode
  isActive?: boolean
  isDisabled?: boolean
}

const AdsTableItem: FC<AdsTableItemProps> = ({
  className,
  columns,
  actions,
  outsideSlot,
  isActive,
  isDisabled,
}) => {
  const matches = useMediaQuery('(max-width: 768px)')
  const labels: Array<string> = columns.reduce<Array<string>>(
    (acc, next) => (next.label ? [...acc, next.label] : acc),
    []
  )

  return (
    <>
      {labels.length === columns.length && !matches && (
        <SC.Item>
          {columns.map((column, idx) => {
            return (
              <SC.Column
                key={idx}
                $withoutBackground
                $withoutPadding
                $shrink={column.shrink}
              >
                <SC.Label>{column.label}</SC.Label>
                <SC.Line />
              </SC.Column>
            )
          })}
          <SC.Column $withoutPadding $withoutBackground></SC.Column>
        </SC.Item>
      )}
      <SC.Item className={cx('TableItem', className)} $isDisabled={isDisabled}>
        {matches && <SC.Strip $isActive={isActive} />}
        {columns.map((column, idx) => {
          return (
            <SC.Column key={idx} $shrink={column.shrink}>
              {idx === 0 && !matches && <SC.Strip $isActive={isActive} />}
              <SC.Value $firstRow={idx == 0} onClick={column.onClick}>
                {column.value}
              </SC.Value>
              {(idx !== columns.length - 1 || actions?.length > 0) && (
                <Fragment>
                  <SC.Separator $mobile />
                  <SC.Separator $desktop />
                </Fragment>
              )}
            </SC.Column>
          )
        })}
        {actions && (
          <SC.Column $shrink className={'columnAction'}>
            <SC.Value $actions>
              {actions.map((action, idx) => (
                <SC.Button key={idx} {...action} $isActive={isActive} />
              ))}
            </SC.Value>
          </SC.Column>
        )}
        {outsideSlot && (
          <SC.Column $withoutBackground $withPadding>
            {outsideSlot}
          </SC.Column>
        )}
      </SC.Item>
    </>
  )
}

export default AdsTableItem
